// removed by extract-text-webpack-plugin
module.exports = {"Base":"FeaturedArticleBlock__Base-3ZKiy","Figure":"FeaturedArticleBlock__Figure-lBW0Z CategoryHero__Figure-20aWY","FigureLink":"FeaturedArticleBlock__FigureLink-3bvIO CategoryHero__FigureLink-39UJJ","Image":"FeaturedArticleBlock__Image-3hKze CategoryHero__Image-ldOGJ","ContentWrapper":"FeaturedArticleBlock__ContentWrapper-2QLc6","HeaderTab":"FeaturedArticleBlock__HeaderTab-3fUI3","Header":"FeaturedArticleBlock__Header-3P_WL","Title":"FeaturedArticleBlock__Title-4leRX","Title--underlined":"FeaturedArticleBlock__Title--underlined-3riDt FeaturedArticleBlock__Title-4leRX","Content":"FeaturedArticleBlock__Content-E9KKw"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/FeaturedArticleBlock/FeaturedArticleBlock.css
 ** module id = 628
 ** module chunks = 0
 **/